import "./livescore.css";
import {poll} from "./ajax-poll-livescore.js";
import {updateLivescoreUI} from "./livescore-update-data.js";


//html templates for carousel
import {lastVideoTemplate} from "./templates/last-video.js";
import {livescoreSliderWrapperTemplate} from "./templates/livescore-slider-wrap.js";
import {livescoreItemTemplate} from "./templates/livescore-item.js";
import {statusRowContentFuture} from "./templates/status-row-content-future.js";
import {statusRowContentLive} from "./templates/status-row-content-live.js";
import {statusRowContentFinished} from "./templates/status-row-content-finished.js";

//static data for demo purposes
//import livescoreData from "./data/livescore.json";

// Ensure you have `fetch` available, or use a polyfill if needed
(async () => {
  try {
    // Access the global `lscrUrl` variable set by PHP
    const livescoreDataUrl = window.lscrUrl;
    const liveMatchesDataUrl = window.liveMatchesUrl;
    if (!livescoreDataUrl) {
        //return if no data is fetched;
        //console.log('!livescoreDataUrl');
        return;
    }
    // Fetch the JSON data from the URL
    const response = await fetch(livescoreDataUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    // Parse the JSON response
    const data = await response.json();
//    console.log('Fetched LS Data:', data);

    // Use the data in your component
    loadLivescoreData(data);
    
    if (!liveMatchesDataUrl) {
        return;
    } else {
        poll(liveMatchesDataUrl, 10000);        
    }
    
  } catch (error) {
    console.error('Error fetching data:', error);
  }
})();

function livescoreSliderComponent(){    
    let livescoreSliderWrapperElement = livescoreSliderWrapperTemplate();    
    return livescoreSliderWrapperElement;
}

function loadLivescoreData(lsData){
    let sliderComponent = livescoreSliderComponent();
    
    let wrapperElement = '#livescore .carousel-wrapper';
    $(wrapperElement).html(sliderComponent);        
    
    let liveScoreCarouselContentElement = $('#livescore.carousel-slider .carousel-content');
    
    
    //load LiveScore Data
    let dataLength = Object.keys(lsData).length;
    let currentItemElements = [];
    for (let i = 0; i < dataLength; i++) {
        //console.log(lsData['match_' + i].match_info);
        let currentItem;
        let matchId = lsData['match_' + i].match_info.id;
        let statusClass = lsData['match_' + i].match_info.status;
        let date = lsData['match_' + i].match_info.date;
        let hour = lsData['match_' + i].match_info.hour;
        let time = lsData['match_' + i].match_info.minute + "'" +  ( lsData['match_' + i].match_info.added_time ? lsData['match_' + i].match_info.added_time : '' );
        let matchUrl = lsData['match_' + i].match_info.match_url;
        let teamHomeName = lsData['match_' + i].team_home_info.name;
        let teamGuestName = lsData['match_' + i].team_guest_info.name;
        let imgHomeSrc = lsData['match_' + i].team_home_info.logo_url;
        let imgGuestSrc = lsData['match_' + i].team_guest_info.logo_url;
        let statusInfo = "";
        let hasLivestream = lsData['match_' + i].match_info.livestream;        
        let lastVideoTemplatePart = '';
        
        if (statusClass == "future"){
            statusInfo = statusRowContentFuture(date, hour);
        } else if (statusClass == "live"){            
            statusInfo = statusRowContentLive(lsData['match_' + i].team_home_info.score, lsData['match_' + i].team_guest_info.score, time, hasLivestream);
        } else {
            statusInfo = statusRowContentFinished(lsData['match_' + i].team_home_info.score, lsData['match_' + i].team_guest_info.score);
        }
        
        if (lsData['match_' + i].match_info.last_video_thumb != ""){
            lastVideoTemplatePart = lastVideoTemplate(lsData['match_' + i].match_info.last_video_thumb, lsData['match_' + i].match_info.last_video_url);
        };
//        console.log('hasLivestream', hasLivestream);
//        console.log('lastVideoTemplatePart', lastVideoTemplatePart);
        currentItem = livescoreItemTemplate(statusClass, matchId, matchUrl, 
                                            teamHomeName, imgHomeSrc, teamGuestName, imgGuestSrc, 
                                            statusInfo, 
                                            hasLivestream,lastVideoTemplatePart);
        
        currentItemElements.push(currentItem);
    }
    liveScoreCarouselContentElement.append(currentItemElements);
    
}


//console.log('livescore initiated ===============================================');
//for demo purposes
//loadLivescoreData(livescoreData);